import React from "react";

import { ReactComponent as SettingsIcon } from "@common/assets/images/gear-icon.svg";
import Tooltip from "@common/components/Tooltip/Tooltip";

import * as Styled from "./CommonCommentPill.styles";

interface CommonCommentPillProps {
  title: string;
  text: string;
  onClick?: () => void;
}

const CommonCommentPill = ({ title, text, onClick }: CommonCommentPillProps) => {
  return (
    <Tooltip
      style={{ width: "auto" }}
      position={"top"}
      text={`Insert recent “${truncateTooltip(text ?? "")}”`}
    >
      <Styled.Pill onClick={onClick}>
        <Styled.PillText p2>{title}</Styled.PillText>
      </Styled.Pill>
    </Tooltip>
  );
};

interface CommonCommentSettingsProps {
  onClick?: () => void;
}

const CommonCommentSettings = ({ onClick }: CommonCommentSettingsProps) => {
  return (
    <Tooltip
      style={{ width: "auto" }}
      position={"top"}
      text={"Manage common comments"}
    >
      <Styled.Button onClick={onClick}>
        <SettingsIcon />
      </Styled.Button>
    </Tooltip>
  );
};

const truncateTooltip = (text: string, startWords = 6, endWords = 4) => {
  const words = text.split(" ");
  if (words.length <= startWords + endWords) return text;

  return [...words.slice(0, startWords), "(...)", ...words.slice(-endWords)].join(" ");
};

export { CommonCommentPill, CommonCommentSettings };
